<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('materials.title')"/>

        <div class="col-sm-12 nopads my-2">
            <material-type-list
              :materials="results"
              @add="addMaterialType"
              @edit="editMaterialType"
            />
        </div>

        <base-modal v-if="editMode" hide-footer hide-header @close="showMaterialTypes">
            <material-type-editor
                :material-type="materialType"
                @close="showMaterialTypes"
                @close-and-update="closeAndUpdate"
            />
        </base-modal>

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import MaterialTypeList from "@/components/materials/type/MaterialTypeList";
import MaterialTypeEditor from "@/components/materials/type/MaterialTypeEditor";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: "MaterialTypes",
    components: {BaseModal, Navbar, MaterialTypeEditor, MaterialTypeList},
    mixins: [restApi],
    data: function () {
        return {
            editMode: false,
            results: [],
            materialType: null,
            loading: false
        }
    },
    mounted() {
        this.fetchMaterialTypes()
    },
    methods: {
        fetchMaterialTypes: function () {
            this.loading = true
            this.restFetch(this.materialTypeUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        addMaterialType: function () {
            this.materialType = {
                id: -1,
                name: null
            }
            this.editMode = true
        },
        editMaterialType: function (type) {
            this.materialType = type
            this.editMode = true
        },
        showMaterialTypes: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchMaterialTypes()
            this.showMaterialTypes()
        }
    }
}
</script>
